export default "__VITE_ASSET__CgPQX6MJ__"